<template>
  <v-dialog :value="value" width="500px" persistent @input="$emit('input', false)">
    <v-card>
      <v-card-title>
        <span class="section-title">Ajustar pontos</span>
      </v-card-title>
      <v-card-text>
        <v-row class="py-0">
          <v-col class="py-1">
            <span class="card-title pl-0">{{ user.name }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-1">
            <span class="card-title pl-0">{{ user.document_no | cpfCnpj }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-1">
            <span class="card-title pl-0"
              >Pontos atuais: <span class="card-title-highlighted pl-0">{{ getSafe(() => user.points.total) || 0 | localeString }}</span></span
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-3 pb-0">
            <v-text-field
              v-model="adjustedPoints"
              v-money="vPoints"
              autofocus
              data-cy="userPoints"
              outlined
              hide-details
              label="Nova quantidade de pontos"
              @keydown="$event.key === '-' ? $event.preventDefault() : null"
            />
            <p class="subtitle pt-2">
              A quantidade inserida sobrescreverá a quantidade atual de pontos. Para acrescentar ou remover pontos, insira aqui o novo total.
            </p>
          </v-col>
        </v-row>
        <mf-action-buttons
          :primary-button="{ text: 'Salvar', action: save, isVisible: true, isLoading: loading }"
          :extra-button="{ text: 'Cancelar', action: () => $emit('input', false), isVisible: true, isDisabled: loading }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal from 'sweetalert2'
import { MUTATION_ADJUST_POINTS } from '@/modules/clientes/gerenciamento/graphql'
import { VMoney } from 'v-money'

export default {
  directives: { money: VMoney },
  props: {
    value: Boolean,
    user: Object,
  },
  data: () => ({
    vPoints: { thousands: '.', precision: 0 },
    adjustedPoints: '0',
    loading: false,
    visible: false,
  }),
  computed: {
    pointsAdjustment() {
      const currentPoints = this.user?.points?.total || 0
      return parseInt(this.adjustedPoints.replace(/[^0-9]/g, '')) - currentPoints
    },
  },
  watch: {
    value() {
      this.adjustedPoints = '0'
      this.$v.$reset()
    },
  },
  methods: {
    async save() {
      const confirmed = await this.$confirm({
        title: 'Salvar alterações',
        message:
          'Todas as alterações serão disponibilizadas no aplicativo imediatamente, e na plataforma após a próxima atualização.  Deseja realmente fazer essa alteração?',
        confirmText: 'Salvar',
        confirmColor: 'primary',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return

      this.loading = true
      try {
        const result = await this.$apollo.mutate({
          mutation: MUTATION_ADJUST_POINTS,
          variables: {
            userId: this.user._id,
            pointsAdjustment: this.pointsAdjustment,
          },
        })

        const { success, error } = result.data.adjustPoints

        if (success) {
          Swal.fire({
            text: 'Pontos alterados com sucesso',
            icon: 'success',
            showConfirmButton: false,
            timer: 1000,
            customClass: {
              content: 'content-class',
            },
          })
          this.$emit('input', false)
          this.$emit('save')
        } else {
          this.handleAdjustPointsError(error)
        }

        this.loading = false
      } catch (e) {
        this.$snackbar({ message: 'Ocorreu um erro ao ajustar os pontos' })
        this.loading = false
      }
    },
    handleAdjustPointsError(error) {
      const errorMessages = {
        USER_HAS_ACTIVE_VOUCHER: 'Impossível diminuir o saldo. Consumidor com vale-troca ativo.',
        USER_HAS_INSUFFICIENT_POINTS: 'Não é possível remover pontos pois o usuário não possui pontos suficientes',
      }

      const message = errorMessages[error] || 'Erro desconhecido ao ajustar os pontos'
      this.$snackbar({ message, snackbarColor: 'error' })
    },
  },
}
</script>
